import { useSelector } from 'react-redux';

export default function useNewsroom() {
    return useSelector((state) => state.newsroom);
}
